import { useTranslation } from "react-i18next";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { useDietContext } from "@/contexts/DietContext";
import { useDietForm } from "@/hooks/useDietForm";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export const DietInfoStep = () => {
    const { t } = useTranslation();
    const { formData, setFormData, setStep } = useDietContext();
    const { calculateCalories } = useDietForm();

    const onNextStep = () => {
        calculateCalories();
        setStep((prev) => prev + 1);
    };

    const onBackStep = () => {
        setStep((prev) => prev - 1);
    };

    return (
        <div className="space-y-6 max-w-2xl mx-auto">
            <div className="text-center mb-12">
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                    {t("buildDiet.dietInfo.title")}
                </h1>
            </div>
            <div className="space-y-4">
                <Label htmlFor="lifestyle">
                    {t("buildDiet.dietInfo.lifestyle.label")}
                </Label>
                <Select
                    onValueChange={(value) =>
                        setFormData((prev) => ({
                            ...prev,
                            lifestyle: value,
                        }))
                    }
                    value={formData.lifestyle}
                >
                    <SelectTrigger className="w-full">
                        <SelectValue
                            placeholder={t(
                                "buildDiet.dietInfo.lifestyle.options.placeholder",
                            )}
                        />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="sedentary">
                            {t(
                                "buildDiet.dietInfo.lifestyle.options.sedentary",
                            )}
                        </SelectItem>
                        <SelectItem value="normal">
                            {t("buildDiet.dietInfo.lifestyle.options.normal")}
                        </SelectItem>
                        <SelectItem value="active">
                            {t("buildDiet.dietInfo.lifestyle.options.active")}
                        </SelectItem>
                        <SelectItem value="athletic">
                            {t("buildDiet.dietInfo.lifestyle.options.athletic")}
                        </SelectItem>
                    </SelectContent>
                </Select>
            </div>

            <div className="space-y-2">
                <Label htmlFor="lifestyle">
                    {t("buildDiet.dietInfo.target.label")}
                </Label>
                <Select
                    onValueChange={(value) =>
                        setFormData((prev) => ({ ...prev, target: value }))
                    }
                    value={formData.target}
                >
                    <SelectTrigger className="w-full">
                        <SelectValue
                            placeholder={t(
                                "buildDiet.dietInfo.target.options.placeholder",
                            )}
                        />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="fastWeightLoss">
                            {t(
                                "buildDiet.dietInfo.target.options.fastWeightLoss",
                            )}
                        </SelectItem>
                        <SelectItem value="normalWeightLoss">
                            {t(
                                "buildDiet.dietInfo.target.options.normalWeightLoss",
                            )}
                        </SelectItem>
                        <SelectItem value="slowWeightLoss">
                            {t(
                                "buildDiet.dietInfo.target.options.slowWeightLoss",
                            )}
                        </SelectItem>
                        <SelectItem value="maintenance">
                            {t("buildDiet.dietInfo.target.options.maintenance")}
                        </SelectItem>
                        <SelectItem value="lightMuscleGain">
                            {t(
                                "buildDiet.dietInfo.target.options.lightMuscleGain",
                            )}
                        </SelectItem>
                        <SelectItem value="normalMuscleGain">
                            {t(
                                "buildDiet.dietInfo.target.options.normalMuscleGain",
                            )}
                        </SelectItem>
                        <SelectItem value="fastMuscleGain">
                            {t(
                                "buildDiet.dietInfo.target.options.fastMuscleGain",
                            )}
                        </SelectItem>
                    </SelectContent>
                </Select>
            </div>

            {/* Pulsanti Back e Next */}
            <div>&nbsp;</div>
            <div className="max-w-2xl mx-auto flex justify-between pt-4 border-t border-gray-800 ">
                <Button variant="outline" onClick={onBackStep}>
                    {t("buildDiet.back")}
                </Button>
                <Button
                    onClick={onNextStep}
                    disabled={!formData.target || !formData.lifestyle}
                >
                    {t("buildDiet.next")}
                </Button>
            </div>
        </div>
    );
};
